/**
 * Changes the input field of the form
 *
 * @param  {form} form The new text of the input field
 *
 * @return {object}    An action object with a type of CHANGE_USERNAME
 */
import {
  VALUE_CHANGED,
  LOAD,
  UPLOAD_FILE,
  UPLOAD_PERCENTAGE,
  UPLOAD_PROGRESS_VISIBILITY,
  UPLOAD_FILE_SUCCESS,
  REMOVE_FILE,
  REMOVE_FILE_SUCCESS,
  LOAD_CLAIM_ATTACHMENTS,
  LOAD_CLAIM_ATTACHMENTS_SUCCESS,
  RESET,
  UPLOAD_FILE_DOC,
} from './constants';

export function loadFormData(form) {
  return {
    type: LOAD,
    payload: form,
  };
}

export function handleFormDataChange(propertyName, value) {
  return {
    type: VALUE_CHANGED,
    propertyName,
    value,
  };
}

export function uploadFile(files, benefitCode) {
  return {
    type: UPLOAD_FILE,
    files,
    benefitCode,
  };
}

export function uploadRequireDocFile(files, benefitCode, requiredDocumentId) {
  return {
    type: UPLOAD_FILE_DOC,
    files,
    benefitCode,
    requiredDocumentId,
  };
}

export function uploadProgress(percent) {
  return {
    type: UPLOAD_PERCENTAGE,
    percent,
  };
}

export function uploadProgressVisibility(visible) {
  return {
    type: UPLOAD_PROGRESS_VISIBILITY,
    visible,
  };
}

export function uploadFileSuccess(fileInfo) {
  const { file, attachmentId, benefitCode } = fileInfo;
  file.id = attachmentId;
  file.benefitCode = benefitCode;
  file.requiredDocumentId = 0;
  file.groupName = 'Supporting Document';
  return {
    type: UPLOAD_FILE_SUCCESS,
    file,
  };
}

export function uploadRequiredFileSuccess(fileInfo) {
  const { file, attachmentId, benefitCode, requiredDocumentId } = fileInfo;
  file.id = attachmentId;
  file.benefitCode = benefitCode;
  file.requiredDocumentId = requiredDocumentId;
  return {
    type: UPLOAD_FILE_SUCCESS,
    file,
  };
}

export function removeFile(file) {
  return {
    type: REMOVE_FILE,
    file,
  };
}

export function removeFileSuccess(file) {
  return {
    type: REMOVE_FILE_SUCCESS,
    file,
  };
}

export function resetFormData() {
  return {
    type: RESET,
  };
}

export function loadClaimAttachments() {
  return {
    type: LOAD_CLAIM_ATTACHMENTS,
  };
}

export function loadClaimAttachmentsSuccess(files) {
  return {
    type: LOAD_CLAIM_ATTACHMENTS_SUCCESS,
    files,
  };
}



// WEBPACK FOOTER //
// ./app/containers/FastCover/StepSupportingDocuments/actions.js